import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaVeTVPricesRestService_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultaVeTVPricesRest",
    rutaEndPoint: "/ConsultaVeTVPricesRest",
    sistemaOrigen: "Web",
    AGREGAR_ENCABEZADO: false,
    DESTINO_SERVICIO: DestinoConexion.BackendSelfService,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA
export interface ConsultaVeTVPricesRestService_entrada {
    code: string
}


export function builtConsultaVeTVPricesRestServiceEntrada(p_code: string) {
    var retorno: ConsultaVeTVPricesRestService_entrada ={
        code: p_code
  };
  return retorno;
}



//SALIDA
export interface ConsultaVeTVPricesRestService_salida {
    CODE: string
    CONCEPT_PAYMENT: string
    PRICE: number
    respuesta: string
    ID: number
    respuestaCode: string
    REGISTRATION_DATE: string
  }
  


export type ConsultaVeTVPricesRestService_Respuesta = ConsultaVeTVPricesRestService_salida;